// extracted by mini-css-extract-plugin
module.exports = {"body":"Congratulation_body__g33gS","inner_div":"Congratulation_inner_div__1swUf","buttonWrapper":"Congratulation_buttonWrapper__3aE3t"};